import React from "react";
import Modal from "../modal/Modal";

const PathwayItemDetailsModal = ({ isOpen, onClose, item }) => {
  if (!item) return null;

  const getTypeLabel = (type) => {
    switch (type) {
      case "aiTool":
        return "AI Tool";
      case "certificate":
        return "Certificate";
      case "skill":
      default:
        return "Skill";
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} width="w-[600px]">
      <div className="space-y-1 p-1">
        {/* Header */}
        <div>
          <h2 className="text-lg font-bold text-blue-900">
            {item.name }
          </h2>
        </div>

        {/* Category (if exists) */}
        {item.category && (
          <div>
            <span className="text-sm text-gray-600 font-semibold">Category: </span>
            <span className="text-sm text-gray-500">{item.category}</span>
          </div>
        )}

        {/* Type */}
        <div>
          <span className="text-sm text-gray-600 font-semibold">Type: </span>
          <span className="text-sm text-gray-500">{getTypeLabel(item.type)}</span>
        </div>

        {/* Description */}
        <div>
          <p className="text-gray-500 text-sm">
            {item.description || item.services || ""}
          </p>
        </div>

        {/* Recommendation Reason */}
        <div>
          <span className="text-sm text-gray-600 font-semibold">Why recommended: </span>
          <span className="text-sm text-gray-500">
            {item.reason || "This item is recommended for your learning pathway."}
          </span>
        </div>

        {/* Link (if exists) */}
        {item.link && (
          <div className="pt-4 flex justify-end">
            <a 
              href={item.link} 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block px-5 mb-3 py-2 bg-blue-800 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200 shadow-sm"
            >
              Open {item.name || 'Resource'}
            </a>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PathwayItemDetailsModal;